import dayjs from "dayjs"
import { MailReportType } from "../../data/Types"
import { useContext } from "react"
import { SidePanelContext } from "../contexts/SidePanelContext"
import { returnHumanizedMailtype } from "../../services/functions"
import { ReactComponent as EYE } from "../../assets/EyeICON.svg"
import { Tag } from "antd"

type BaseMailPreviewDataRowType = {
    index: number
    item: MailReportType
    sidePanelConId: number
    mailType?: boolean
    setResendUri: (e: string) => void
    setMailPreviewContent: (e: string) => void
    setMailReportId?: (e: string | undefined) => void
}

export default function BaseMailPreviewDataRow(props: BaseMailPreviewDataRowType) {
    const sidePanelCon = useContext(SidePanelContext)
    return (
        <div className={`flex flex-row px-8 w-full ${props.mailType ? "border-b py-2" : "pb-4"}`}>
            <div className="flex flex-col text-xs text-black/30 w-2/3">
                {props.mailType && <p>Type: {returnHumanizedMailtype(props.item.mailType)}</p>}
                <p>Versandt am: {dayjs(props.item.date).format("DD.MM.YYYY")}</p>
                <p className="truncate">
                    Versandt an: {props.item?.mailReceivers?.map((receiver: string) => receiver + (props.item?.mailReceivers.indexOf(receiver) + 1 !== props.item.mailReceivers.length ? ", " : ""))}
                </p>
                <div className="flex flex-wrap pt-1">
                    {props.item?.version === 1 ? (
                        props.item?.mailDeliverySuccess ? (
                            <Tag color="green">Erfolgreich</Tag>
                        ) : (
                            <Tag color="red">Fehlgeschlagen</Tag>
                        )
                    ) : props.item?.version === 2 ? (
                        props.item?.notifuseEvents?.map((event: any) => (
                            <Tag color={"grey"}>
                                {event.eventType === "email.sent" ? "Versendet" : event.eventType === "email.clicked" ? "Angeklickt" : event.eventType === "email.opened" ? "Geöffnet" : ""}
                            </Tag>
                        ))
                    ) : undefined}
                </div>
            </div>
            <div className="flex flex-col gap-1 text-xs text-black/30 items-end w-1/3">
                <button
                    onClick={() => {
                        props.setMailReportId?.(props.item._id)
                        props.setResendUri(props.item.resendUri)
                        props.setMailPreviewContent(props.item.mailContent)
                        sidePanelCon?.trigger(props.sidePanelConId)
                    }}
                    disabled={!props.item.mailContent}
                    className="sm:px-8 btn btn-outline btn-primary btn-sm sm:btn-xs">
                    <p className="hidden sm:block">Vorschau</p>
                    <EYE className="w-6 h-6 sm:hidden" />
                </button>
            </div>
        </div>
    )
}
